import { BehaviorSubject } from "rxjs";

export const PerpectiveSubject = new BehaviorSubject({});
